/**
 * Oturumun nerede durduğunu bilen tek yer.
 *
 * Artık varsayılan yol ÇEREZ: token'ı sunucu HttpOnly `ris_at` çerezine yazıyor, JavaScript onu
 * göremiyor (XSS ile çalınamaz). Uygulamanın "girişliyim" bilgisini yine de round-trip'siz bilmesi
 * gerektiği için sunucu yanına HttpOnly OLMAYAN bir işaret çerezi (`ris_auth`) koyuyor — içinde sır
 * yok, yetkiyi her zaman HttpOnly olan taşıyor.
 *
 * localStorage'daki token KALDIRILMADI: güncellemeden önce giriş yapmış kullanıcıların elinde hâlâ
 * geçerli (7 günlük) token var ve kimse oturumdan atılmasın istiyoruz. Açılışta o token'la bir kez
 * Auth/Session çağrılıp çereze taşınıyor (upgradeLegacySession), sonra localStorage temizleniyor.
 * O çağrı başarısız olursa token yerinde kalır ve istekler eskisi gibi Authorization header'ı ile
 * gider — yani en kötü durumda davranış bugünküyle aynıdır.
 */

const HINT_COOKIE = 'ris_auth';
const LEGACY_TOKEN_KEY = 'token';

/** Sunucunun kurduğu işaret çerezi duruyor mu? */
function hasCookieSession() {
    return document.cookie
        .split('; ')
        .some(item => {
            const [name, ...rest] = item.split('=');
            return name === HINT_COOKIE && rest.join('=') !== '';
        });
}

/** Güncelleme öncesinden kalan token (varsa). */
function getLegacyToken() {
    return localStorage.getItem(LEGACY_TOKEN_KEY) || '';
}

function clearLegacyToken() {
    localStorage.removeItem(LEGACY_TOKEN_KEY);
}

function isAuthenticated() {
    return hasCookieSession() || !!getLegacyToken();
}

export const SessionService = {
    hasCookieSession,
    getLegacyToken,
    clearLegacyToken,
    isAuthenticated,
};
